import axios from 'axios';

const initForm = (form) => {
    // You can add any additional logic for each form here if needed
    const validator = new ContactFormValidator({
        element: form,
        hasOverlayingLabels: true,
        redesign: true,
        vueForm: false,
    });
    form.addEventListener('submit', async function(e) {
        e.preventDefault();
        if (!await validator.isValid()) {
            return false;
        }
        reCaptchaProtect(() => {
            const formData = new FormData(form);
            validator.preventInput();
            axios.post(form.getAttribute('action'), formData)
                .then(response => {
                    if (typeof response.data.html !== 'undefined') {
                        const unsubContentArea = document.querySelector('#unsub-content');
                        if (unsubContentArea) {
                            unsubContentArea.innerHTML = response.data.html;
                        }
                        validator.allowInput();
                        return;
                    }
                    validator.allowInput();
                })
                .catch(error => {
                    validator.allowInput();
                    validator.errorResponse(error);
                });
        });
    });
    return true;
};

const forms = document.querySelectorAll('form[data-form-name="Unsubscribe"]');
forms.forEach(form => {
    initForm(form);
});

const showServiceRemindersButton = document.querySelector('#show_service_reminders');
if (showServiceRemindersButton) {
    showServiceRemindersButton.addEventListener('click', function(e){
        const serviceReminders = document.querySelector('#service-reminders');
        if (serviceReminders) {
            serviceReminders.style.display = (serviceReminders.style.display === 'none' || serviceReminders.style.display === '') ? 'block' : 'none';
        }
    });
}